import {
  InventoryTypeKey,
  InventoryTypeId
} from '@carvana/merch-contracts/InventoryType';
import { assetsCdnUrl, vexCdnUrl } from '~/constants/environment';

type OwnProps = {
  jellyBeanMobileUrl?: string;
  stockNumber: number;
  vehicleInventoryType: InventoryTypeId | InventoryTypeKey;
};

export default function getImageToUse({
  jellyBeanMobileUrl,
  stockNumber,
  vehicleInventoryType
}: OwnProps) {
  const hasJellyBeanUrl = Boolean(jellyBeanMobileUrl);
  const hasStockNumber = Boolean(stockNumber);
  const isWip =
    vehicleInventoryType === InventoryTypeId.WIP ||
    vehicleInventoryType === InventoryTypeKey.WIP;

  if (!hasStockNumber && !hasJellyBeanUrl) {
    return `${assetsCdnUrl}/search-assets/noevox.png`;
  }

  return isWip
    ? (jellyBeanMobileUrl as string)
    : `${vexCdnUrl}/${stockNumber}/standardizedHero.jpg?width=256&crop=4:3`;
}
